import { useEffect, useRef, useState } from "react";
import { ConfigProvider, Button, Form, Input, Select, Modal, Spin, Empty, Pagination, message } from "antd";
import type { PaginationProps } from "antd";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { publicPath } from "@/utils/base";
import { appNameReg } from "@/utils/constant";
import { getSuperDeviceTemplateDetail, setEnable } from "@/utils";
import api from "@/api";
import apiAuth from "@/api/auth";

import "./index.less";

import dataJson from "@/../public/data.json";
import { cloneDeep } from "lodash-es";
const prefix = "superDeviceTemplate";

function SuperDeviceTemplate() {
  const { super_device_template, req_err, create, two_bars, super_device_template_detail, release, add_create } = dataJson;

  const filterFormJson = super_device_template.filter_form;
  const addFormJson = super_device_template.add_form;

  const [addOpen, setAddOpen] = useState(false);
  const [addOpenLoading, setAddFormLoading] = useState(false);
  const [kaihongTotal, setKaihongTotal] = useState<number>(0);
  const [myTotal, setMyTotal] = useState<number>(0);
  const [kaihongPageData, setKaihongPageData] = useState<any[]>([]);
  const [myPageData, setMyPageData] = useState<any[]>([]);
  const [kaihongLoading, setKaihongLoading] = useState(false);
  const [myLoading, setMyLoading] = useState(false);

  const [filterForm] = Form.useForm();

  const [addForm] = Form.useForm();
  const navigate = useNavigate();
  // const userData = useSelector((state: any) => state.userData);

  const kaihongPageInit = {
    pageSize: 5,
    pageNo: 1,
  };
  const myPageInit = {
    pageSize: 10,
    pageNo: 1,
  };
  const kaihongPageNo = useRef<number>(kaihongPageInit.pageNo);
  const kaihongPagesize = useRef<number>(kaihongPageInit.pageSize);
  const myPageNo = useRef<number>(myPageInit.pageNo);
  const myPagesize = useRef<number>(myPageInit.pageSize);

  const onFilter = () => {
    kaihongPageNo.current = kaihongPageInit.pageNo;
    kaihongPagesize.current = kaihongPageInit.pageSize;
    getKaihongPageData();
    myPageNo.current = myPageInit.pageNo;
    myPagesize.current = myPageInit.pageSize;
    getMyPageData();
  };

  const kaihongSizeChange: PaginationProps["onShowSizeChange"] = (current, pageSize) => {
    kaihongPagesize.current = pageSize;
  };
  const mySizeChange: PaginationProps["onShowSizeChange"] = (current, pageSize) => {
    myPagesize.current = pageSize;
  };

  const getKaihongPageData = async () => {
    try {
      setKaihongLoading(true);
      const filterFormValues = await filterForm.getFieldsValue();

      const res: any = await api.getSuperDeviceListApi({
        page: kaihongPageNo.current,
        limit: kaihongPagesize.current,
        appBelong: super_device_template_detail.template_type[0],
        keyword: filterFormValues.name
      });
      if (res.code === 200) {
        const dataCopy = cloneDeep(res.data.datas);
        const list = dataCopy.map((item: any) => {
          if (item.photoUrl) {
            item.iconImg = item.photoUrl.includes('http') ? item.photoUrl : null;
          }
          return item;
        });

        setKaihongPageData(list);
        setKaihongTotal(Number(res?.data?.total));
        setKaihongLoading(false);
      } else {
        setKaihongLoading(false);
        message.error(res.msg || req_err);
      }
    } catch (errorInfo: any) {
      console.error(errorInfo);
      setKaihongPageData([]);
      setKaihongTotal(0);
      setKaihongLoading(false);
    }
  };
  const getMyPageData = async () => {
    try {
      setMyLoading(true);
      const filterFormValues = await filterForm.getFieldsValue();

      const res: any = await api.getSuperDeviceListApi({
        page: myPageNo.current,
        limit: myPagesize.current,
        appBelong: super_device_template_detail.template_type[1],
        keyword: filterFormValues.name
      });
      if (res.code === 200) {
        const dataCopy = cloneDeep(res.data.datas);
        const list = dataCopy.map((item: any) => {
          if (item.photoUrl) {
            item.iconImg = item.photoUrl.includes('http') ? item.photoUrl : null;
          }
          return item;
        });

        setMyPageData(list);
        setMyTotal(Number(res?.data?.total));
        setMyLoading(false);
      } else {
        setMyLoading(false);
        message.error(res.msg || req_err);
      }
    } catch (errorInfo: any) {
      console.error(errorInfo);
      setMyPageData([]);
      setMyTotal(0);
      setMyLoading(false);
    }
  };

  const validateName = (_: any, value: any) => {
    if (value) {
      return api.checkSuperDeviceNameApi({ name: value }).then((resp: any) => {
        if (resp.code === 200) {
          if (resp.data?.exist) {
            return Promise.reject(new Error(super_device_template.name_already));
          }
        } else {
          return Promise.reject(resp.msg);
        }
      });
    } else {
      return Promise.resolve();
    }
  };

  const showAddModal = () => {
    setAddOpen(true);
  };

  const handleAddOpenOk = async () => {
    try {
      const addValues = await addForm.validateFields();
      setAddFormLoading(true);
      const res: any = await api.addSuperDeviceApi({
        name: addValues.name,
      });
      if (res.code === 200) {
        message.success(super_device_template.creat_success);
        setAddOpen(false);
        setAddFormLoading(false);
        setEnable('')
        navigate(`${publicPath}/super_device_template_detail/info/${res.data.id}`);
      } else {
        setAddFormLoading(false);
        message.error(res.msg || req_err);
      }
    } catch (errorInfo: any) {
      console.error(errorInfo);
      setAddFormLoading(false);
    }
  };

  const handleAddCancel = () => {
     addForm.resetFields();
    setAddOpen(false);
  };

  const clickCard = (item: any, enable?: boolean) => {
    if (enable) {
      setEnable(enable.toString())
    } else {
      setEnable('')
    }
    // getSuperDeviceTemplateDetail(item.id, () => {
      navigate(`${publicPath}/super_device_template_detail/info/${item.id}`);
    // });
  };

  useEffect(() => {
    getKaihongPageData();
    getMyPageData();
  }, []);

  useEffect(() => {
    apiAuth.bindKaihongProducts()
  }, [])

  return (
    <div className={prefix}>
      <div className={`${prefix}-top`}>
        <Form form={filterForm} layout="inline">
          <Form.Item
            name="name"
            getValueFromEvent={(e) => e.target.value.replace(/(^\s*)|(\s*$)/g, "")}
            style={{ marginRight: 56 }}
          >
            <Input placeholder={filterFormJson.name_placeholder} onPressEnter={onFilter} style={{ width: 296 }} />
          </Form.Item>
        </Form>
        <ConfigProvider
          theme={{
            components: {
              Button: {
                borderRadius: 0,
                paddingInline: 40,
                paddingBlock: 8,
              },
            },
          }}
        >
          <Button type="primary" onClick={showAddModal}>
            新建
          </Button>
        </ConfigProvider>
      </div>
      <Spin spinning={kaihongLoading} size="large" wrapperClassName={`${prefix}-spin`}>
        <div className={`${prefix}_title`}>{super_device_template.kaihon_template}</div>
        {kaihongTotal === 0 ? (
          <Empty />
        ) : (
          <div className={`${prefix}-content kaihong_page`}>
            {kaihongPageData.map((item: any) => {
              return (
                <div
                  key={item.id}
                  onClick={() => {
                    clickCard(item, true);
                  }}
                  className={`${prefix}-content-item`}
                >
                  <div className={`${prefix}-content-inner`}>
                    <img
                      src={item?.iconImg ? item?.iconImg : super_device_template.init_img}
                      alt=""
                      className={`${prefix}-content-item_initImg`}
                    />
                    <div>
                      <div title={item?.name} className={`${prefix}-content-title one-line-ellipsis`}>
                        {item?.name || two_bars}
                      </div>
                      <div>
                        {super_device_template.node_number}&nbsp;{item.nodeCount}
                      </div>
                      <div>
                        {super_device_template.rules_number}&nbsp;{item.ruleCount}
                      </div>
                    </div>
                    <img
                      src={super_device_template.kaihongLeft_bgImg}
                      alt=""
                      className={`${prefix}-content-item_bgImg`}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        )}
        <Pagination
          pageSize={kaihongPagesize.current}
          current={kaihongPageNo.current}
          total={kaihongTotal}
          showSizeChanger
          showQuickJumper
          showTotal={(total) => `共 ${total} 条`}
          align="end"
          className={`${prefix}_page`}
          onShowSizeChange={kaihongSizeChange}
          onChange={(page: number) => {
            kaihongPageNo.current = page;
            getKaihongPageData();
          }}
        />
      </Spin>
      <Spin spinning={myLoading} size="large" wrapperClassName={`${prefix}-spin`}>
        <div className={`${prefix}_title`}>{super_device_template.my_template}</div>
        {myTotal === 0 ? (
          <Empty />
        ) : (
          <div className={`${prefix}-content my_page`}>
            {myPageData.map((item: any) => {
              return (
                <div
                  key={item.id}
                  onClick={() => {
                    clickCard(item);
                  }}
                  className={`${prefix}-content-item`}
                >
                  <div className={`${prefix}-content-inner`}>
                    <img
                      src={item?.iconImg ? item?.iconImg : super_device_template.init_img}
                      alt=""
                      className={`${prefix}-content-item_initImg`}
                    />
                    <div>
                      <div title={item?.name} className={`${prefix}-content-title one-line-ellipsis`}>
                        {item?.name || two_bars}
                      </div>
                      <div>
                        {super_device_template.node_number}&nbsp;{item.nodeCount}
                      </div>
                      <div>
                        {super_device_template.rules_number}&nbsp;{item.ruleCount}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        <Pagination
          pageSize={myPagesize.current}
          current={myPageNo.current}
          total={myTotal}
          showSizeChanger
          showQuickJumper
          showTotal={(total) => `共 ${total} 条`}
          align="end"
          className={`${prefix}_page`}
          onShowSizeChange={mySizeChange}
          onChange={(page: number) => {
            myPageNo.current = page;
            getMyPageData();
          }}
        />
      </Spin>
      <Modal
        title={create}
        centered
        confirmLoading={addOpenLoading}
        open={addOpen}
        okText={add_create}
        onOk={handleAddOpenOk}
        onCancel={handleAddCancel}
        width={328}
      >
        <Form form={addForm} layout="vertical">
          <Form.Item
              name="name"
              label={addFormJson.name_label}
              validateDebounce={500}
              rules={[
                { required: true, message: addFormJson.name_placeholder },
                { validator: validateName },
              ]}
          >
            <Input showCount maxLength={64} placeholder={addFormJson.name_placeholder} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default SuperDeviceTemplate;
